import { inflate } from 'pako';
export function unzip(input) {
    return inflate(input);
}
//# sourceMappingURL=unzip.js.map